import React from "react";
import { Table, Tag, Button } from "antd";
import { useAtom } from "jotai";
import { useListarHistoricoDescansoMedico } from "../../hooks";
import { detalleSeleccionadoAtom } from "../../DescansoMedicoStore";

const formatoDias = (valor) => (valor === null || valor === undefined ? "-" : Number(valor).toString());

const TablaHistoricoDescansoMedico = () => {
  const { historicoFiltrado: historico, loading } = useListarHistoricoDescansoMedico();
  const [, setDetalleSeleccionado] = useAtom(detalleSeleccionadoAtom);

  const columnas = [
    {
      title: "DNI",
      dataIndex: "colaboradorNumeroDocumentoIdentidad",
      align: "center",
    },
    {
      title: "Colaborador",
      dataIndex: "colaboradorNombreCompleto",
      align: "left",
    },
    {
      title: "Año",
      dataIndex: "anio",
      align: "center",
    },
    {
      title: "Histórico (Excel)",
      dataIndex: "diasHistorico",
      align: "center",
      render: formatoDias,
    },
    {
      title: "En el Sistema",
      dataIndex: "diasSistema",
      align: "center",
      render: formatoDias,
    },
    {
      title: "Total Acumulado",
      dataIndex: "diasAcumulados",
      align: "center",
      render: formatoDias,
      sorter: (a, b) => (a.diasAcumulados || 0) - (b.diasAcumulados || 0),
    },
    {
      title: "Días Subsidiados",
      dataIndex: "diasSubsidiados",
      align: "center",
      render: formatoDias,
    },
    {
      title: "En Subsidio",
      dataIndex: "enSubsidio",
      align: "center",
      render: (valor) =>
        valor ? <Tag color="red">SÍ</Tag> : <Tag color="green">NO</Tag>,
    },
    {
      title: "Acciones",
      align: "center",
      render: (_, fila) => (
        <Button type="link" onClick={() => setDetalleSeleccionado(fila)}>
          Detalle
        </Button>
      ),
    },
  ];

  return (
    <Table
      rowKey={(r) => `${r.colaboradorNumeroDocumentoIdentidad}-${r.anio}`}
      dataSource={historico}
      columns={columnas}
      loading={loading}
      pagination={{ pageSize: 20, showTotal: (total) => `Total ${total} registros` }}
      style={{ marginTop: "10px" }}
    />
  );
};

export default TablaHistoricoDescansoMedico;
